import styled from 'styled-components'
import { Skeleton as SkeletonComponent } from '~/shared/ui/SkeletonList'

export const ButtonOptionWrapper = styled.div`
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Skeleton = styled(SkeletonComponent)`
  margin-bottom: 0px;
  height: 20px;
  border-radius: 4px;
`
